module.exports = __webpack_public_path__ + "static/media/display07.b82a7867.jpg";